import { Instagram, Linkedin, Facebook, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import { LOGO_URL, COMPANY } from "@/lib/api";

const LINKS = {
  company: [
    { label: "Home", to: "/" },
    { label: "Services", to: "/services" },
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
  ],
  services: [
    { label: "Performance Marketing", to: "/services" },
    { label: "Creative & Branding", to: "/services" },
    { label: "Funnels & Landing Pages", to: "/services" },
    { label: "Social Media Growth", to: "/services" },
    { label: "Local SEO", to: "/services" },
    { label: "AI Automation", to: "/services" },
  ],
};

const SOCIALS = [
  { icon: Instagram, href: "https://www.instagram.com/goldmindbusinessofficial", label: "Instagram" },
  { icon: Facebook, href: "https://www.facebook.com/goldmindbusinessofficial", label: "Facebook" },
  { icon: Youtube, href: "https://www.youtube.com/@goldmindbusinessofficial", label: "YouTube" },
  { icon: Linkedin, href: "https://www.linkedin.com/company/goldmindbusiness/", label: "LinkedIn" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#111827] text-gray-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Gold Mind Business" loading="lazy" decoding="async" className="h-11 w-11 object-contain" />
            <div className="leading-tight">
              <div className="font-display text-lg font-bold text-white">Gold Mind</div>
              <div className="text-[0.6rem] tracking-[0.3em] uppercase font-accent font-bold text-[#FFC107]">
                Business
              </div>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed max-w-sm">
            Results-driven digital marketing partners. We build complete growth
            systems that generate consistent leads, sales and long-term revenue.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                aria-label={s.label}
                className="h-10 w-10 flex items-center justify-center rounded-full border border-gray-700 hover:border-[#B01116] hover:bg-[#B01116] hover:text-white text-gray-400 transition-colors"
              >
                <s.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="font-accent font-bold text-white uppercase tracking-wider text-sm mb-5">Quick Links</div>
          <ul className="space-y-3">
            {LINKS.company.map((l) => (
              <li key={l.label}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-sm hover:text-[#FFC107] transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="font-accent font-bold text-white uppercase tracking-wider text-sm mb-5">Services</div>
          <ul className="space-y-3">
            {LINKS.services.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm hover:text-[#FFC107] transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="font-accent font-bold text-white uppercase tracking-wider text-sm mb-5">Get in touch</div>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={`tel:${COMPANY.phone}`} className="hover:text-[#FFC107] transition-colors" data-testid="footer-phone">
                {COMPANY.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} className="hover:text-[#FFC107] transition-colors" data-testid="footer-email">
                {COMPANY.email}
              </a>
            </li>
            <li className="leading-relaxed">{COMPANY.address}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs">© {new Date().getFullYear()} Gold Mind Business. All rights reserved.</p>
          <p className="text-xs">
            Crafted with <span className="text-[#B01116]">●</span> in New Delhi
          </p>
        </div>
      </div>
    </footer>
  );
}
